export const publicPath = "/";

export default {
  ABOUT: `${publicPath}acerca-de-abcya`,
  CATEGORYGAMES: `${publicPath}juegos/categoria`,
  CATEGORYPRINTABLES: `${publicPath}recursos-imprimibles/categoria`,
  COMPLETESIGNUP: `${publicPath}suscribirse/finalizar`,
  COMPLETESIGNUP_STUDENT: `${publicPath}suscribirse/finalizar/estudiante`,
  CONTACT: `${publicPath}soporte`,
  EMAIL_PREFERENCES: `${publicPath}email/preferencias`,
  FAQ: `${publicPath}preguntas-frecuentes`,
  FEEDBACK: `${publicPath}comentarios`,
  FORGOT: `${publicPath}restablecer-contrasena`,
  GAMES: `${publicPath}juegos/`,
  GIFTCARD: `${publicPath}tarjeta-de-regalo`,
  GRADES: `${publicPath}grados`,
  HOME: `${publicPath}`,
  LOGIN: `${publicPath}iniciar-sesion`,
  MANAGE: `${publicPath}administrar`,
  MOBILEGAMES: `${publicPath}juegos/celular`,
  GAMEPROXY: `${publicPath}gameproxy`,
  NOTFOUND: `${publicPath}sin-resultados`,
  PARTEA: `${publicPath}padres-docentes`,
  PAYTERMS: `${publicPath}condiciones-de-pago`,
  PRINTABLES: `${publicPath}recursos-imprimibles/`,
  PRIVACY: `${publicPath}privacidad`,
  PRODUCTOFFERINGS: `${publicPath}oferta-de-productos`,
  REDEEM: `${publicPath}canjear`,
  REDEEMCARD: `${publicPath}canjear-tarjeta`,
  SEARCH: `${publicPath}buscar`,
  STORY: `${publicPath}nuestra-historia`,
  SUBSCRIBE: `${publicPath}suscribirse/`,
  SUBSCRIBE_FAMILY: `${publicPath}suscribirse/familia`,
  SUBSCRIBE_CLASSROOM: `${publicPath}suscribirse/clase`,
  TEAM: `${publicPath}equipo`,
  TERMS: `${publicPath}condiciones`,
  TESTIMONIALS: `${publicPath}testimonios`,
  TOOLS: `${publicPath}herramientas`,
  TRYMOBILE: `${publicPath}preguntas-frecuentes/probar-app`,
  UPDATEPASSWORD: `${publicPath}restablecer-contrasena/contrasena`,
  VERIFY: `${publicPath}verificar`,
};
